// extracted by mini-css-extract-plugin
export var container = "_6b-0";
export var error = "_6b-9";
export var label = "_6b-5";
export var light = "_6b-6";
export var md = "_6b-3";
export var sm = "_6b-2";
export var thin = "_6b-8";
export var thinBold = "_6b-7";
export var vertical = "_6b-4";
export var xs = "_6b-1";